import React, { useEffect } from "react";
import { useMiniGameAuth } from "@pages/Events/MiniGame/store";
import ComponentGive from "./ComponentGive";

export default function GivePiece() {
  const { isAuthenticated, requireLogin } = useMiniGameAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      requireLogin();
    }
  }, [isAuthenticated, requireLogin]);

  if (!isAuthenticated) {
    return null;
  }

  return <ComponentGive />;
}
